import { UserInfoListDto } from "../../services";
import { PermissionManager } from "./PermissionManager";

type props = {
  user: UserInfoListDto | null;
  children: JSX.Element;
};

export function RequireEditContentPermission({ user, children }: props) {
  return <>{PermissionManager.canEditContent(user) ? children : <></>}</>;
}
